import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { colors } from '../constants';

/**
 * Modal wrapper for create/edit forms. Renders children in the body and a
 * cancel/submit footer. Submission is driven by the parent via `onSubmit`.
 */
export default function FormDialog({
  open,
  title,
  children,
  onClose,
  onSubmit,
  submitLabel = 'Save',
  loading = false,
  maxWidth = 'sm',
  disableSubmit = false,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth>
      <DialogTitle sx={{ fontWeight: 700, pr: 6 }}>
        {title}
        <IconButton
          onClick={onClose}
          sx={{ position: 'absolute', right: 12, top: 12 }}
          size="small"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Box
          component="form"
          id="inv-form-dialog"
          noValidate
          onSubmit={(e) => {
            e.preventDefault();
            if (onSubmit) onSubmit(e);
          }}
          sx={{
            pt: 1,
            // Symmetric spacing: reserve a fixed gap under every field so all
            // fields line up consistently, and render helper/validation text as
            // an overlay inside that gap. This guarantees showing/hiding a
            // validation message never resizes or shifts any field.
            '& .MuiTextField-root': { position: 'relative', mb: 2.5 },
            '& .MuiTextField-root .MuiFormHelperText-root': {
              position: 'absolute',
              top: '100%',
              left: 0,
              mt: '2px',
              mx: 0,
              lineHeight: 1.2,
            },
          }}
        >
          {children}
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose} sx={{ textTransform: 'none' }} disabled={loading}>
          Cancel
        </Button>
        <Button
          type="submit"
          form="inv-form-dialog"
          variant="contained"
          disabled={loading || disableSubmit}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            backgroundColor: colors.primary,
            '&:hover': { backgroundColor: colors.primaryDark },
          }}
        >
          {submitLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
